import { FC } from 'react';
import { isMobile } from 'react-device-detect';
// Types
import { GetStreamParticipants_getStreamParticipants_entities } from 'api/streams/types/GetStreamParticipants';
import { UserRole } from 'api/graphql-global-types';
// Components
import FollowButton from 'components/FollowButton/FollowButton';
import LinkButton from 'ui3/LinkButton/LinkButton';
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
import Modal from 'ui3/Modal/Modal';
// Helpers
import { withCDN } from 'helpers/cdn';
// Styles
import styles from './ParticipantsListModal.module.scss';

type ParticipantsListModalProps = {
  participants: GetStreamParticipants_getStreamParticipants_entities[];
  onClose: () => void;
  isInterview?: boolean;
};

const ParticipantsListModal: FC<ParticipantsListModalProps> = ({
  participants,
  onClose,
  isInterview = false,
}) => {
  const renderParticipantItem = (
    participant: GetStreamParticipants_getStreamParticipants_entities
  ) => {
    const {
      id,
      firstName,
      lastName,
      avatarUrl,
      storeDetails,
      role,
      slug,
    } = participant;
    const name =
      `${firstName || ''} ${lastName || ''}` ||
      `${storeDetails?.storeName || ''}` ||
      '';
    const isFanUser = role === UserRole.Customer;
    const avatar =
      avatarUrl ||
      storeDetails?.avatarURL ||
      withCDN('/images/logos/mobile-logo-black.svg');
    const participantStore = !isFanUser
      ? ({
          id,
          slug,
          storeDetails,
        } as any)
      : null;

    return (
      <div key={id} className={styles.participantItem}>
        <div className={styles.avatarWrapper}>
          <img src={avatar} alt={name} className={styles.avatar} />
        </div>
        <div className={styles.detailsWrapper}>
          <span className={styles.name}>{name}</span>
        </div>
        <div className={styles.buttonsWrapper}>
          {participantStore && (
            <FollowButton
              store={participantStore}
              startIcon="plus"
              unfollowStartIcon="minus"
              unfollowText="Following"
              className={styles.followButton}
              xs="small"
              followVariant="secondary"
              unfollowVariant="secondary"
              iconOnly={isMobile}
            />
          )}
          {isFanUser ? (
            <span className={styles.disabledButton}>View</span>
          ) : (
            <LinkButton
              size="small"
              variant="secondary"
              subVariant="text"
              className={styles.viewProfileButton}
              link={`/${slug}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              View
            </LinkButton>
          )}
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={true}
      onClose={onClose}
      size="small"
      blockScroll={true}
      showCloseIcon={false}
      className={styles.modal}
    >
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <h2 className={styles.modalTitle}>
            {isInterview ? 'Guests' : 'Participants'}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className={styles.closeButton}
            aria-label="Close"
          >
            <MillionsIcon name="close" size={24} className={styles.closeIcon} />
          </button>
        </div>

        <div className={styles.participantsList}>
          {participants.length > 0 ? (
            participants.map(renderParticipantItem)
          ) : (
            <div className={styles.emptyState}>
              <p>No participants found</p>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ParticipantsListModal;
